<p-toast></p-toast>
<div class="app-verification-container mt-2">
        <div class="card dashboardTable">
            <p-table #miPondTable [value]="estimationTableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                'AppId',
                'OutletId',
                'Outlets',
                'ConId',
                'AgreementNo',
                'Program_Name',
                'ChunkId',
                'XEN_Status',
                'XEN_Remarks',
                'JE_Status',
                'JE_Remarks',
                ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
                [tableStyle]="{'max-width': '80rem'}">
                <ng-template pTemplate="caption">
                    <div class="grid d-flex align-items-center justify-content-end"
                        [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                        <!-- Left side -->
                        <div class="col-12 md:col-4">
                            <!-- <button pButton pRipple label="{{'ADD_TARGET'| translate}}" icon="pi pi-plus"
                                class="p-button-success mr-2" (click)="addTarget()"></button> -->
                        </div>
                        <!-- Middle section for buttons -->
                        <div class="col-0 md:col-4 d-flex justify-content-center">
                            <button *ngIf="estimationTableData.length>0" (click)="menu.toggle($event)" pButton pRipple
                                label="{{'' | translate}}" icon="pi pi-download" class="p-button-help"></button>
                            <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
                            <button (click)="refreshTable()" pButton pRipple label="{{''| translate}}"
                                icon="pi pi-refresh" class="p-button-info ml-3"></button>
                        </div>
                        <!-- Right side for search -->
                        <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="miPondTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                            <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                                    class="p-button-help mx-1"></button>
                                <p-menu #menu [popup]="true" [model]="exportMenu"></p-menu> -->
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'APP_ID'| translate}}</th>
                        <th>{{'OUTLET'| translate}}</th>
                        <th>{{'AGREEMENT_NO'| translate}}</th>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <th>{{'CHUNK'| translate}}</th>
                        <th>{{'XEN_STATUS'| translate}}</th>
                        <th>{{'XEN_REMARKS'| translate}}</th>
                        <th>{{'JE_STATUS'| translate}}</th>
                        <th>{{'JE_REMARKS'| translate}}</th>
                        <!-- <th>{{'PROGRAMME_TYPE'| translate}}
                            <p-columnFilter type="text" field="ProgramType" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'PROGRAMME_NAME'| translate}}</th>
                        <th>{{'USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                        </th>
                        <th>{{'CASTE'| translate}}</th>
                        <th>{{'AREA'| translate}}</th>
                        <th>{{'TOTAL_APP'| translate}}</th>
                        <th>{{'START_DATE'| translate}}</th>
                        <th>{{'END_DATE'| translate}}</th>
                        <th>{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                        </th> -->
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-val let-ri="rowIndex">
                    <!-- <tr class="body-section"> -->
                    <tr class="body-section"
                        [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(val)}">
                        <!-- <td>{{ ri + 1 }}</td> -->
                        <td>{{val?.AppId}}</td>
                        <td>{{val?.Outlets}}</td>
                        <td>{{val?.AgreementNo}}</td>
                        <td>{{val?.Program_Name}}</td>
                        <td>{{val?.ChunkId}}</td>
                        <td>{{val?.XEN_Status}}</td>
                        <td>{{val?.XEN_Remarks}}</td>
                        <td>{{val?.JE_Status}}</td>
                        <td>{{val?.JE_Remarks}}</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{estimationTableData ?
                            estimationTableData.length : 0 }} {{'RECORDS_ADDED'| translate}}
                        </p>
                        <!-- <div class="flex  justify-content-between flex-column ">
                            <div class="flex">
                                <div
                                    style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'ACTIVE' | translate}}
                            </div>
                            <div class="flex">
                                <div
                                    style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                </div>{{'INACTIVE' | translate}}
                            </div>
                        </div> -->
                    </div>
                </ng-template>

            </p-table>
        </div>
</div>


<!-- <p-confirmDialog>
    <ng-template pTemplate="message" let-message>
        <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
            <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmDialog> -->